// legacy FEC1 vuex local storage item

import { LocalStorage } from '~/models'
import type { CheckoutCartModel } from '~/models/checkout-cart'

// TODO: FEC1 draft object has many more properties
type VuexLocalStorage = {
  appliedCouponCode?: string
  cart: CheckoutCartModel
  owner?: string
  draft?: { draftId?: string }
}

const DEFAULT_VUEX_VALUE: VuexLocalStorage = {
  cart: {
    ePrescriptions: [],
    prescriptions: [],
    products: [],
  },
}

export const resetLegacyVuex = () => {
  const vuex = useLegacyVuex()
  vuex.value = JSON.parse(JSON.stringify(DEFAULT_VUEX_VALUE))
}

// TODO: Remove after FEC2.0 migration
export const useLegacyVuex = () => useLocalStorage<VuexLocalStorage>(LocalStorage.Vuex, DEFAULT_VUEX_VALUE, { initOnMounted: true })
